<template>
  <div class="ll-logo">
    <img
      class="logo"
      :src="logo"
    >
  </div>
</template>
<script>
export default {
  name: "LlLogo",
  data: () => ({
    logo: require("@/assets/image/logo-horizontal.svg"),
  }),
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/ll-logo";
</style>